/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const ProductTestingTypes = {
  // GET
  GET_JOB_LIST: asyncActionType('GET_JOB_LIST'),
  GET_COUNTRIES_LIST: asyncActionType('GET_COUNTRIES_LIST'),
  GET_JOB_DETAIL: asyncActionType('GET_JOB_DETAIL'),

  GET_QUOTE_LIST_JOB_DETAIL: asyncActionType('GET_QUOTE_LIST_JOB_DETAIL'),
  GET_QUOTE_DETAIL_JOB_DETAIL: asyncActionType('GET_QUOTE_DETAIL_JOB_DETAIL'),
  GET_REPORT_LIST_JOB_DETAIL: asyncActionType('GET_REPORT_LIST_JOB_DETAIL'),
  GET_REPORT_DETAIL_JOB_DETAIL: asyncActionType('GET_REPORT_DETAIL_JOB_DETAIL'),
  GET_ATTACHMENT_LIST_JOB_DETAIL: asyncActionType('GET_ATTACHMENT_LIST_JOB_DETAIL'),
  GET_INVOICE_JOB_DETAIL: asyncActionType('GET_INVOICE_JOB_DETAIL'),
  GET_INVOICE_LIST_JOB_DETAIL: asyncActionType('GET_INVOICE_LIST_JOB_DETAIL'),
  GET_LOG_LIST_JOB_DETAIL: asyncActionType('GET_LOG_LIST_JOB_DETAIL'),
  GET_TAG_LIST_JOB_DETAIL: asyncActionType('GET_TAG_LIST_JOB_DETAIL'),
  GET_FAILURE_RECORD_LIST_JOB_DETAIL: asyncActionType('GET_FAILURE_RECORD_LIST_JOB_DETAIL'),
  GET_FAILURE_RECORD_DETAIL_JOB_DETAIL: asyncActionType('GET_FAILURE_RECORD_DETAIL_JOB_DETAIL'),

  GET_PRODUCT_LIST: asyncActionType('GET_PRODUCT_LIST'),
  GET_SUPPLIER_LIST: asyncActionType('GET_SUPPLIER_LIST'),
  GET_TAG_LIST: asyncActionType('GET_TAG_LIST'),
  GET_LAB_LIST: asyncActionType('GET_LAB_LIST'),
  GET_LAB_OPTIONAL_LIST: asyncActionType('GET_LAB_OPTIONAL_LIST'),
  GET_REPORT_LAB_LIST: asyncActionType('GET_REPORT_LAB_LIST'),
  GET_REPORT_CITATION_LIST: asyncActionType('GET_REPORT_CITATION_LIST'),
  GET_REPORT_TEST_ITEM_LIST: asyncActionType('GET_REPORT_TEST_ITEM_LIST'),
  GET_SERVICE_PROVIDER: asyncActionType('GET_SERVICE_PROVIDER'),
  GET_ANALYTICS_DATA: asyncActionType('GET_ANALYTICS_DATA'),
  GET_QUOTE_TEST_ITEM_LIST: asyncActionType('GET_QUOTE_TEST_ITEM_LIST'),

  // CREATE
  CREATE_JOB: asyncActionType('CREATE_JOB'),
  CREATE_QUOTE: asyncActionType('CREATE_QUOTE'),
  CREATE_REPORT: asyncActionType('CREATE_REPORT'),
  CREATE_FAILURE_RECORD: asyncActionType('CREATE_FAILURE_RECORD'),
  CREATE_INVOICE_JOB_DETAIL: asyncActionType('CREATE_INVOICE_JOB_DETAIL'),

  // DUPLICATE
  DUPLICATE_JOB: asyncActionType('DUPLICATE_JOB'),

  // ADD
  ADD_ATTACHMENT_JOB_DETAIL: asyncActionType('ADD_ATTACHMENT_JOB_DETAIL'),
  ADD_INVOICE_JOB_DETAIL: asyncActionType('ADD_INVOICE_JOB_DETAIL'),
  ADD_TAG_JOB_DETAIL: asyncActionType('ADD_TAG_JOB_DETAIL'),

  // UPDATE
  UPDATE_JOB_DETAIL: asyncActionType('UPDATE_JOB_DETAIL'),
  UPDATE_ADMIN_STATUS_JOB_DETAIL: asyncActionType('UPDATE_ADMIN_STATUS_JOB_DETAIL'),
  UPDATE_LINKAGE: asyncActionType('UPDATE_LINKAGE'),
  UPDATE_QUOTE: asyncActionType('UPDATE_QUOTE'),
  UPDATE_REPORT: asyncActionType('UPDATE_REPORT'),
  UPDATE_FAILURE_RECORD: asyncActionType('UPDATE_FAILURE_RECORD'),
  UPDATE_INVOICE_JOB_DETAIL: asyncActionType('UPDATE_INVOICE_JOB_DETAIL'),

  // DELETE
  DELETE_ATTACHMENT_JOB_DETAIL: asyncActionType('DELETE_ATTACHMENT_JOB_DETAIL'),
  DELETE_INVOICE_JOB_DETAIL: asyncActionType('DELETE_INVOICE_JOB_DETAIL'),
  DELETE_TAG_JOB_DETAIL: asyncActionType('DELETE_TAG_JOB_DETAIL'),
  DELETE_LAB_JOB_DETAIL: asyncActionType('DELETE_LAB_JOB_DETAIL'),
  DELETE_REPORT: asyncActionType('DELETE_REPORT'),
  DELETE_FAILURE_RECORD: asyncActionType('DELETE_FAILURE_RECORD'),

  // DOWNLOAD
  DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL: asyncActionType('DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL'),
  DOWNLOAD_REPORT_LIST_JOB_DETAIL: asyncActionType('DOWNLOAD_REPORT_LIST_JOB_DETAIL'),
  DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL: asyncActionType('DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL'),
  DOWNLOAD_INVOICE_LIST_JOB_DETAIL: asyncActionType('DOWNLOAD_INVOICE_LIST_JOB_DETAIL'),

  // SHARE
  SHARE_REPORT: asyncActionType('SHARE_REPORT'),
  GET_SHARE_REPORT: asyncActionType('GET_SHARE_REPORT'),
};
